import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: events.ValueLimit.
export default class ValueLimit extends Fragment {
  declare [Type]: 'events/value-limit';

  @attr('string', { defaultValue: '' })
  declare value: string;

  @attr('number', { defaultValue: 0 })
  declare limit: number;
}
